<template>
  <div class="version-layout">
    <div class="right-title">科技日报</div>
    <div class="news-config">
      <div class="news-time">
        <el-date-picker
          v-model="timeValue"
          type="date"
          placeholder="选择时间"
          size="large"
          :clearable="false"
          format="YYYY年MM月DD日  dddd"
          :disabled-date="disabledDate"
          @panel-change="handlePanelChange"
          @visible-change="openPanel"
          :popper-options="{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [30, 10], // [水平偏移, 垂直偏移]
                },
              },
            ],
          }"
        >
        </el-date-picker>
      </div>
      <el-space wrap>
        <el-button class="lastIssue" @click="changePeriod('pre')"
          >上一期</el-button
        >
        <el-button class="nextIssue" @click="changePeriod('next')"
          >下一期</el-button
        >
      </el-space>
    </div>
    <div class="has-version">
      <Loading :loading="props.homeRightLoading" />
      <div class="version-list">
        <div
          class="version-item"
          v-for="(item, index) in props.totalVersion"
          :key="index"
          @click="change(item)"
          :class="{
            'active-item': item.id === currentVersion?.id,
            'long-name': item.editionName.length > 21,
          }"
        >
          {{ item.editionName }}
        </div>
      </div>
      <ul class="news-list">
        <li
          class="news-item"
          @mouseenter="
            () => {
              currentArticleId = item?.id;
            }
          "
          @mouseleave="
            () => {
              currentArticleId = '';
            }
          "
          v-for="(item, index) in articleList"
          :key="index"
          @click="toInfo(item)"
          :class="[currentArticleId == item?.id && 'active-news-item']"
          v-html="
            item.title &&
            item.title.replace(/<p\b[^>]*>|<\/p>/g, (match) =>
              match.startsWith('</') ? '</div>' : '<div>'
            )
          "
        ></li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watchEffect, onMounted, nextTick } from "vue";
import Loading from "@/components/Loading/index.vue";
const props = defineProps([
  "currentVersion",
  "currentNews",
  "totalPeriod",
  "totalVersion",
  "articleList",
  "hasPermission",
  "homeRightLoading",
]);
const emits = defineEmits(["changeVersion", "openInfo", "changePeriod"]);
const timeValue = defineModel("timeValue");
const currentMonth = defineModel("currentMonth");
const currentArticleId = ref("");
//处理月份中不存在期次的日期，设置时间筛选框这些日期不可选择
const disabledDate = (time) => {
  // 标准化日期格式为时间戳（去除时分秒）
  const normalizeDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return isNaN(date.getTime())
      ? null
      : new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
  };
  // 预处理禁用的日期
  const disabledDateTimestamps = props.totalPeriod
    ?.map(normalizeDate)
    .filter((timestamp) => timestamp !== null);

  const normalizedTime = new Date(time).setHours(0, 0, 0, 0);
  return !disabledDateTimestamps?.includes(normalizedTime);
};

//切换期次
const changePeriod = (type) => {
  emits("changePeriod", type);
};

//切换日报版本
const change = (item: number) => {
  emits("changeVersion", item);
};

//打开报纸详情
const toInfo = (item: Object) => {
  emits("openInfo", item);
};
//打开时间面板触发的函数
const openPanel = () => {
  console.log("面板打开了");
  nextTick(() => {
    const headerLabels = document.querySelectorAll(
      ".el-date-picker__header-label"
    );

    headerLabels.forEach((label) => {
      // 阻止点击事件
      label.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      // 可选：禁用鼠标交互
      label.style.pointerEvents = "none";
      label.style.cursor = "default";
    });
  });
};
//切换面板月份触发的函数
const handlePanelChange = (date) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const currentTime = `${year}-${month}-01`;
  console.log("currentTime", currentTime);
  currentMonth.value = `${year}-${month}`;
};

watchEffect(() => {});
onMounted(() => {
  const headerLabels = document.querySelectorAll(
    ".el-date-picker__header-label"
  );

  headerLabels.forEach((label) => {
    // 阻止点击事件
    label.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });
});
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.version-layout {
  width: 100%;
  height: 100%;
  border-radius: 0.9rem;
  filter: blur(0);
  .mini-app {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 10.2rem;
    height: 14rem;
    right: -10.2rem;
    bottom: 1rem;
    .qr-code {
      width: 100%;
      height: 10.2rem;
    }
    .qr-name {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: 2.8rem;
      padding: 0 0.2rem;
      font-size: 1.2rem;
      font-weight: 600;
      border-radius: 0.8rem;
      border: 1px solid rgba(0, 0, 0, 0.08);
      img {
        width: 1.5rem;
        height: 1.5rem;
      }
    }
  }
  .right-title {
    width: 100%;
    height: 4.5rem;
    font-weight: 600;
    font-size: 3.2rem;
    text-align: left;
  }
  .news-config {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 3.2rem;
    line-height: 3.2rem;
    margin-top: 2rem;
  }
  .news-time {
    display: flex;
    align-content: center;
    font-size: 1.4rem;

    .news-name {
      margin-right: 1rem;
    }
  }

  :deep(.el-input__wrapper) {
    width: 20rem;
    height: 3.2rem;
    border-radius: 0.8rem;
  }
  :deep(.el-input__inner) {
    width: 21rem;
    font-size: 1.4rem;
  }

  :deep(.el-icon) {
    width: 1.5rem;
    height: 1.5rem;
    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  .lastIssue,
  .nextIssue {
    display: flex;
    align-items: center;
    width: 8rem;
    height: 3.2rem;
    border-radius: 0.8rem;
    border: 0.1rem solid #0d59fa;
    opacity: 0.8;
    font-size: 1.4rem;
    color: #0d59fa;
  }
  .has-version {
    position: relative;
    width: 100%;
    height: 52.2rem;
    margin-top: 1rem;
  }
  .version-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.8rem;
    width: 100%;
    //height: 13.2rem;
    padding: 1.2rem 2.4rem;
    background: #d8e1f2;
    opacity: 0.8;
    border-radius: 1.2rem;

    .version-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 17.2rem;
      min-height: 4.8rem;
      background: #5a8fff;
      border-radius: 0.8rem;
      font-size: 1.6rem;
      color: #ffffff;
      cursor: pointer;
    }
    .active-item {
      background: #0d59fa;
    }
    .long-name {
      font-size: 1.2rem !important;
    }
  }
  .news-list {
    width: 100%;
    height: 40rem;
    overflow-y: auto;
    margin-top: 1rem;
    box-sizing: border-box;
    padding: 0 0.6rem;
    .news-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: auto;
      box-sizing: border-box;
      padding: 1.2rem 0.6rem;
      list-style: none;
      border-bottom: 0.1rem solid #edf0f6;
      font-weight: 400;
      font-size: 1.6rem;
      color: #000000;
      text-align: left;

      &:last-child {
        border-bottom: none;
      }
    }

    .active-news-item {
      background: #e5eefb;
      border-radius: 0.5rem;
    }
    .news-item::before {
      content: "";
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      background-color: #3f5b98;
      border-radius: 50%;
      margin-right: 0.5rem;
      vertical-align: middle;
    }
    .news-item p {
      margin-block: 0 !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }
  .news-list::-webkit-scrollbar {
    width: 0.2rem; /* 滚动条宽度（变细） */
    background: transparent; /* 滚动条轨道透明 */
  }
  .news-list::-webkit-scrollbar-thumb {
    background: #e5e5e5; /* 滑块颜色 */
    border-radius: 0.1rem; /* 滑块圆角 */
  }
  .news-list::-webkit-scrollbar-thumb:hover {
    background: #ffffff; /* 悬停时颜色 */
  }
}
</style>